/**
 * Convivium — Ricettario Save System
 * localStorage + Customer Metafield sync for saved recipes
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'convivium_saved_recipes';
  var METAFIELD_NS = 'custom';
  var METAFIELD_KEY = 'saved_recipes';

  /* ── localStorage helpers ────────────────────────────────────────── */

  function getSaved() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (_) {
      return [];
    }
  }

  function setSaved(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  }

  function isSaved(handle) {
    return getSaved().indexOf(handle) !== -1;
  }

  function toggleSave(handle) {
    var list = getSaved();
    var idx = list.indexOf(handle);
    var saved;
    if (idx === -1) {
      list.push(handle);
      saved = true;
    } else {
      list.splice(idx, 1);
      saved = false;
    }
    setSaved(list);
    syncToCustomer(list);
    return saved;
  }

  /* ── Customer metafield sync (new accounts only) ─────────────────── */

  function isLoggedIn() {
    return !!window.__conviviumCustomerToken;
  }

  function syncToCustomer(handles) {
    if (!isLoggedIn()) return;

    var query = 'mutation($input: CustomerInput!) { customerUpdate(input: $input) { customer { id } userErrors { field message } } }';

    fetch('/account/customer/api/unstable/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': window.__conviviumCustomerToken },
      body: JSON.stringify({
        query: 'mutation { metafieldsSet(metafields: [{ namespace: "' + METAFIELD_NS + '", key: "' + METAFIELD_KEY + '", value: ' + JSON.stringify(JSON.stringify(handles)) + ', type: "json" }]) { metafields { id } userErrors { field message } } }'
      })
    }).catch(function () {});
  }

  function loadFromCustomer(callback) {
    if (!isLoggedIn()) { callback(getSaved()); return; }

    fetch('/account/customer/api/unstable/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': window.__conviviumCustomerToken },
      body: JSON.stringify({
        query: '{ customer { metafield(namespace: "' + METAFIELD_NS + '", key: "' + METAFIELD_KEY + '") { value } } }'
      })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var remote = [];
      try {
        remote = JSON.parse(data.data.customer.metafield.value) || [];
      } catch (_) {}

      // Merge localStorage + remote (union, no duplicates)
      var local = getSaved();
      var merged = local.slice();
      remote.forEach(function (h) {
        if (merged.indexOf(h) === -1) merged.push(h);
      });

      setSaved(merged);
      if (merged.length !== remote.length) syncToCustomer(merged);
      callback(merged);
    })
    .catch(function () {
      callback(getSaved());
    });
  }

  /* ── UI: update all heart buttons on page ────────────────────────── */

  function updateAllHearts() {
    var saved = getSaved();
    document.querySelectorAll('[data-save-handle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-save-handle');
      var isFav = saved.indexOf(handle) !== -1;
      btn.classList.toggle('is-saved', isFav);
      btn.setAttribute('aria-label', isFav ? 'Rimuovi dalla raccolta' : 'Salva ricetta');
    });
  }

  /* ── Il riquadro ─────────────────────────────────────────────────── */

  /* Sta in cv-carrello.js e vale per tutto il sito. Prima questo file cercava
     #mp-toast o #pr-toast e se non li trovava se ne faceva uno suo, con un altro
     nome e un altro stile: tre riquadri possibili per lo stesso gesto, a seconda
     di che pagina eri. */
  function showToast(msg) {
    if (window.Convivium && window.Convivium.toast) window.Convivium.toast(msg);
  }

  /* ── Init: bind all heart buttons ────────────────────────────────── */

  function init() {
    // Bind clicks
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-save-handle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var handle = btn.getAttribute('data-save-handle');
      var saved = toggleSave(handle);

      updateAllHearts();
      showToast(saved ? 'Ricetta salvata' : 'Ricetta rimossa');

      // Dispatch event for ricettario page to react
      document.dispatchEvent(new CustomEvent('ricettario:change', {
        detail: { handle: handle, saved: saved }
      }));
    });

    // Initial state
    loadFromCustomer(function () {
      updateAllHearts();
    });
  }

  /* ── Public API ──────────────────────────────────────────────────── */

  window.ConviviumRicettario = {
    getSaved: getSaved,
    isSaved: isSaved,
    updateAllHearts: updateAllHearts,
    init: init
  };

  // Auto-init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
